import get from 'lodash.get';
import * as React from 'react';

import { ErrorProps } from './types';
import muiStyles from '../fieldStyles';

export default function ErrorMessage(props: ErrorProps) {
    const {
        id,
        error,
        form,
        field
    } = props;

    const classes = muiStyles(props);

    return (
        get(form.touched, field.name) && error ? (
            <div
                className={classes.fieldError}
                id={id ? `${id}_errorMessage` : undefined}
            >
                {error}
            </div>
        )
            : (<div className={classes.emptyError} />)
    );
}